/**
 * Rough Guides horizontal infinite rail — append via collection products.json.
 * Feeds click / dwell / scroll-depth into wmnEngagement + wmnIntentField
 * (same affinity path as discover / For you).
 */
(function () {
  'use strict';

  var SOURCE = 'rough-guides-rail';
  var VISIBLE_MS = 1000;
  var HOVER_MS = 500;
  var SCROLL_THROTTLE_MS = 200;
  var DEPTH_MARKS = [0.25, 0.5, 0.75, 1];

  /** Tell homepage For you + discover to re-rank (rail-only — avoids discover thrash). */
  function notifyAffinity(reason, meta) {
    try {
      document.dispatchEvent(
        new CustomEvent('wmn:rail-affinity', {
          detail: {
            source: SOURCE,
            reason: reason || 'signal',
            handle: meta && meta.handle ? meta.handle : null,
            title: meta && meta.title ? meta.title : null
          }
        })
      );
    } catch (e) {
      /* ignore */
    }
    // Force remount Picked for you immediately — fingerprint-only remount was
    // leaving stale Mali/India cards on screen while the subtitle updated.
    // Skip while a product link click is navigating; rewriting the page
    // under that click cancels it and the storefront stays put.
    if (window.__wmnProductNavUntil && Date.now() < window.__wmnProductNavUntil) return;
    try {
      if (
        window.wmnForYouFeed &&
        typeof window.wmnForYouFeed.remount === 'function'
      ) {
        window.wmnForYouFeed.remount(
          'force-remount:rail-' + (reason || 'affinity')
        );
      } else if (
        window.wmnForYouFeed &&
        typeof window.wmnForYouFeed.rebuildTail === 'function'
      ) {
        window.wmnForYouFeed.rebuildTail(
          'force-remount:rail-' + (reason || 'affinity')
        );
      }
    } catch (e2) {
      /* ignore */
    }
  }

  /** Always bump engagement entities so homepage Picked for you can expand. */
  function countriesFromGraph(meta) {
    var out = [];
    if (!meta || !meta.handle) return out;
    try {
      if (
        window.wmnCatalogGraph &&
        typeof window.wmnCatalogGraph.resolveProduct === 'function'
      ) {
        var resolved = window.wmnCatalogGraph.resolveProduct(meta.handle);
        var list = (resolved && resolved.countries) || [];
        var i;
        for (i = 0; i < list.length; i++) {
          if (list[i] && list[i] !== 'celtic') out.push(list[i]);
        }
      }
    } catch (e) {
      /* ignore */
    }
    return out;
  }

  function regionsFromGraph(meta) {
    var out = [];
    if (!meta || !meta.handle) return out;
    try {
      if (
        window.wmnCatalogGraph &&
        typeof window.wmnCatalogGraph.resolveProduct === 'function'
      ) {
        var resolved = window.wmnCatalogGraph.resolveProduct(meta.handle);
        var list = (resolved && resolved.regions) || [];
        var i;
        for (i = 0; i < list.length; i++) {
          if (list[i]) out.push(list[i]);
        }
      }
    } catch (e) {
      /* ignore */
    }
    return out;
  }

  function bumpEngagementView(meta, kind, done) {
    if (!meta || !meta.handle) {
      if (done) done();
      return;
    }
    function write() {
      try {
        if (
          window.wmnEngagement &&
          typeof window.wmnEngagement.recordView === 'function'
        ) {
          window.wmnEngagement.recordView({
            handle: meta.handle,
            title: meta.title || '',
            artist: meta.artist || '',
            countries: countriesFromGraph(meta),
            regions: regionsFromGraph(meta),
            kind: kind || 'view'
          });
        }
      } catch (e) {
        /* ignore */
      }
      if (done) done();
    }
    // Wait for graph when possible so country + region resolve lands in entities
    try {
      if (
        window.wmnCatalogGraph &&
        typeof window.wmnCatalogGraph.ensureLoaded === 'function'
      ) {
        window.wmnCatalogGraph.ensureLoaded().then(write).catch(write);
        return;
      }
    } catch (e2) {
      /* fall through */
    }
    write();
  }

  function shopRoot() {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function toSized(url, size) {
    if (!url) return '';
    var u = String(url);
    if (u.indexOf('_') !== -1 && /_\d+x/.test(u)) {
      return u.replace(/_\d+x(?=\.|\?|$)/, '_' + size);
    }
    return u.replace(/(\.\w+)(\?|$)/, '_' + size + '$1$2');
  }

  function productImage(p) {
    if (!p) return '';
    if (p.featured_image) {
      if (typeof p.featured_image === 'string') return p.featured_image;
      if (p.featured_image.src) return p.featured_image.src;
    }
    if (p.images && p.images[0]) {
      return typeof p.images[0] === 'string' ? p.images[0] : p.images[0].src || '';
    }
    return '';
  }

  function isGift(title) {
    var t = String(title || '').toLowerCase();
    return t.indexOf('gift voucher') !== -1 || t.indexOf('gift card') !== -1;
  }

  /** products.json variants use dollar strings ("14.99"); Liquid money uses cents. */
  function parsePriceToCents(raw) {
    if (raw == null || raw === '') return null;
    if (typeof raw === 'number') {
      if (!isFinite(raw) || raw < 0) return null;
      if (raw !== Math.floor(raw)) return Math.round(raw * 100);
      // Integers from Ajax APIs are usually already cents
      return Math.round(raw);
    }
    var s = String(raw).replace(/^\s+|\s+$/g, '');
    if (!s) return null;
    if (s.indexOf('.') !== -1) {
      var f = parseFloat(s);
      return isFinite(f) ? Math.round(f * 100) : null;
    }
    var n = parseInt(s, 10);
    return isFinite(n) ? n : null;
  }

  function productPriceMeta(p) {
    if (!p) return null;
    var variants = p.variants || [];
    var min = null;
    var max = null;
    var i;
    for (i = 0; i < variants.length; i++) {
      var cents = parsePriceToCents(variants[i] && variants[i].price);
      if (cents == null || cents <= 0) continue;
      if (min == null || cents < min) min = cents;
      if (max == null || cents > max) max = cents;
    }
    if (min == null) {
      min = parsePriceToCents(p.price_min != null ? p.price_min : p.price);
      max = parsePriceToCents(p.price_max != null ? p.price_max : p.price);
    }
    if (min == null || min <= 0) return null;
    return {
      min: min,
      varies: max != null && max > min
    };
  }

  function formatMoneyCents(cents) {
    if (cents == null || !(cents > 0)) return '';
    try {
      if (window.wmnMoney && typeof window.wmnMoney.formatCents === 'function') {
        return window.wmnMoney.formatCents(cents);
      }
    } catch (e) {
      /* fall through */
    }
    try {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        var fmt =
          (document.body && document.body.getAttribute('data-money-format')) ||
          '£{{amount}}';
        return Shopify.formatMoney(cents, fmt);
      }
    } catch (e2) {
      /* fall through */
    }
    var pounds = (cents / 100).toFixed(2);
    return '£' + pounds;
  }

  function priceHtml(p) {
    var meta = productPriceMeta(p);
    if (!meta) return '';
    var label = formatMoneyCents(meta.min);
    if (!label) return '';
    if (meta.varies) {
      return (
        '<p class="wmn-rg-rail__price">From <span class="wmn-card-price">' +
        escapeHtml(label) +
        '</span></p>'
      );
    }
    return (
      '<p class="wmn-rg-rail__price"><span class="wmn-card-price">' +
      escapeHtml(label) +
      '</span></p>'
    );
  }

  function spotifyPathForHandle(handle) {
    if (!handle) return '';
    try {
      if (
        window.wmnCatalogGraph &&
        typeof window.wmnCatalogGraph.getSpotifyPath === 'function'
      ) {
        return window.wmnCatalogGraph.getSpotifyPath(handle) || '';
      }
    } catch (e) {
      /* ignore */
    }
    return '';
  }

  function playButtonHtml(handle, sp, source) {
    if (!handle || !sp) return '';
    return (
      '<button type="button" class="wmn-rg-rail__play" data-wmn-play data-wmn-listen data-wmn-handle="' +
      escapeHtml(handle) +
      '" data-wmn-spotify="' +
      escapeHtml(sp) +
      '" data-wmn-play-source="' +
      escapeHtml(source || 'rail') +
      '" aria-label="Play preview" aria-pressed="false">' +
      '<svg class="wmn-rg-rail__play-icon wmn-rg-rail__play-icon--play" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M8 5v14l11-7z"/></svg>' +
      '<svg class="wmn-rg-rail__play-icon wmn-rg-rail__play-icon--pause" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 5h4v14H6zm8 0h4v14h-4z"/></svg>' +
      '</button>'
    );
  }

  function cardHtml(p) {
    if (!p || !p.handle || isGift(p.title)) return '';
    var img = productImage(p);
    if (!img) return ''; // never append blank covers
    var src400 = toSized(img, '400x');
    var src300 = toSized(img, '300x');
    var src600 = toSized(img, '600x');
    var href = shopRoot() + 'products/' + encodeURIComponent(p.handle);
    var artist =
      window.wmnCardKicker
        ? window.wmnCardKicker({
            handle: p.handle,
            title: p.title,
            artist: p.type || p.product_type || p.vendor || '',
            type: p.type || p.product_type || '',
            tags: p.tags
          })
        : p.type || p.vendor || '';
    var sp = spotifyPathForHandle(p.handle);
    return (
      '<li class="wmn-rg-rail__cell" data-wmn-handle="' +
      escapeHtml(p.handle) +
      '"' +
      (sp ? ' data-wmn-spotify="' + escapeHtml(sp) + '"' : '') +
      '>' +
      '<a class="wmn-rg-rail__card" href="' +
      escapeHtml(href) +
      '">' +
      '<div class="wmn-rg-rail__cover">' +
      '<img src="' +
      escapeHtml(src400) +
      '" srcset="' +
      escapeHtml(src300) +
      ' 300w, ' +
      escapeHtml(src400) +
      ' 400w, ' +
      escapeHtml(src600) +
      ' 600w" sizes="(max-width: 640px) 78vw, 520px" alt="" width="400" height="400" loading="lazy" decoding="async" />' +
      '</div>' +
      '<div class="wmn-rg-rail__meta">' +
      (artist
        ? '<p class="wmn-rg-rail__artist">' + escapeHtml(artist) + '</p>'
        : '') +
      '<p class="wmn-rg-rail__name">' +
      escapeHtml(p.title || '') +
      '</p>' +
      priceHtml(p) +
      '</div></a>' +
      playButtonHtml(p.handle, sp, 'rough-guides') +
      '</li>'
    );
  }

  function cellMeta(cell) {
    if (!cell) return null;
    var handle = cell.getAttribute('data-wmn-handle');
    if (!handle) return null;
    var nameEl = cell.querySelector('.wmn-rg-rail__name');
    var artistEl = cell.querySelector('.wmn-rg-rail__artist');
    return {
      handle: handle,
      title: nameEl ? (nameEl.textContent || '').trim() : '',
      artist: artistEl ? (artistEl.textContent || '').trim() : ''
    };
  }

  function logIntent(partial) {
    try {
      if (
        window.wmnEngagement &&
        typeof window.wmnEngagement.logIntent === 'function'
      ) {
        window.wmnEngagement.logIntent(partial);
        return;
      }
      if (
        window.wmnIntentAnalytics &&
        typeof window.wmnIntentAnalytics.log === 'function'
      ) {
        window.wmnIntentAnalytics.log(partial);
      }
    } catch (e) {
      /* ignore */
    }
  }

  function recordClick(meta) {
    if (!meta || !meta.handle) return;
    try {
      if (
        window.wmnEngagement &&
        typeof window.wmnEngagement.recordSearchClick === 'function'
      ) {
        window.wmnEngagement.recordSearchClick({
          handle: meta.handle,
          title: meta.title || '',
          artist: meta.artist || '',
          kind: 'search_click'
        });
      } else if (
        window.wmnIntentField &&
        typeof window.wmnIntentField.onClick === 'function'
      ) {
        window.wmnIntentField.onClick(meta.handle);
        if (typeof window.wmnIntentField.learnFromSignal === 'function') {
          window.wmnIntentField.learnFromSignal('click', true, {
            handle: meta.handle
          });
        }
      }
    } catch (e) {
      /* ignore */
    }
    logIntent({
      type: 'rail_click',
      handle: meta.handle,
      artist: meta.artist || null,
      meta: { source: SOURCE }
    });
    bumpEngagementView(meta, 'view', function () {
      notifyAffinity('click', meta);
    });
  }

  function recordHover(meta, dwellMs) {
    if (!meta || !meta.handle) return;
    var ms = dwellMs || HOVER_MS;
    try {
      if (
        window.wmnIntentField &&
        typeof window.wmnIntentField.onHover === 'function'
      ) {
        window.wmnIntentField.onHover(meta.handle, ms);
        if (typeof window.wmnIntentField.learnFromSignal === 'function') {
          window.wmnIntentField.learnFromSignal('hover', true, {
            handle: meta.handle
          });
        }
      }
    } catch (e) {
      /* ignore */
    }
    logIntent({
      type: 'hover',
      handle: meta.handle,
      artist: meta.artist || null,
      dwellMs: ms,
      meta: { source: SOURCE }
    });
    // Intentional interest — strong geo bump + live For you refresh
    bumpEngagementView(meta, 'hover', function () {
      notifyAffinity('hover', meta);
    });
  }

  /** Re-hover: promote focus only (prefs once-gate already fired). */
  function promoteHoverFocus(meta) {
    if (!meta || !meta.handle) return;
    try {
      if (
        window.wmnEngagement &&
        typeof window.wmnEngagement.promoteFocus === 'function'
      ) {
        window.wmnEngagement.promoteFocus({
          handle: meta.handle,
          title: meta.title || '',
          artist: meta.artist || ''
        });
      }
    } catch (e) {
      /* ignore */
    }
    notifyAffinity('hover', meta);
  }

  /**
   * Confirm pointer is still over the pending cell when HOVER_MS fires
   * (dense rails: neighbor can steal enter while timer was for another).
   */
  function hoverStillOnHandle(expectedHandle, clientX, clientY) {
    if (!expectedHandle) return false;
    if (typeof clientX !== 'number' || typeof clientY !== 'number') return false;
    try {
      if (typeof document.elementFromPoint !== 'function') return true;
      var el = document.elementFromPoint(clientX, clientY);
      if (!el || !el.closest) return false;
      var cell = el.closest('.wmn-rg-rail__cell');
      if (!cell) return false;
      return cell.getAttribute('data-wmn-handle') === expectedHandle;
    } catch (e) {
      return false;
    }
  }

  function recordVisible(meta, dwellMs) {
    if (!meta || !meta.handle) return;
    var ms = dwellMs || VISIBLE_MS;
    // Passive impressions stay analytics-only. onVisible rewrites the intent
    // field, which remounts For You and Dig deeper and the sticky header
    // then yanks the page while the visitor is just scrolling.
    logIntent({
      type: 'visible',
      handle: meta.handle,
      artist: meta.artist || null,
      dwellMs: ms,
      meta: { source: SOURCE }
    });
    // Weak entity bump only — never notifyAffinity (avoids diluting hover geo).
    bumpEngagementView(meta, 'visible');
  }

  function recordScrollDepth(detail) {
    logIntent({
      type: 'scroll_depth',
      meta: {
        source: SOURCE,
        ratio: detail.ratio,
        maxIndex: detail.maxIndex,
        mark: detail.mark,
        collection: detail.collection || null
      }
    });
  }

  /**
   * Soft affinity bump for deep rail exploration (once per mark ≥50%).
   * Uses weak visible weight and does not remount For you (hover/click do).
   */
  function softDepthAffinity(meta, mark) {
    if (!meta || !meta.handle || mark < 0.5) return;
    bumpEngagementView(meta, 'visible');
  }

  function bindTracking(root, scroller, track, collection) {
    if (!root || !scroller || !track) return;
    if (root.getAttribute('data-wmn-rg-track-ready')) return;
    root.setAttribute('data-wmn-rg-track-ready', '1');

    var visibleLogged = {};
    var visibleTimers = {};
    var cellSeenAt = {};
    var observed = typeof WeakSet !== 'undefined' ? new WeakSet() : null;
    var observedFallback = observed ? null : [];
    var maxRatio = 0;
    var maxIndex = 0;
    var firedMarks = {};
    var depthAffinityDone = false;
    var scrollTimer = 0;
    var sectionDwellStarted = 0;
    var sectionDwellLogged = false;

    function alreadyObserved(el) {
      if (observed) return observed.has(el);
      return observedFallback.indexOf(el) !== -1;
    }

    function markObserved(el) {
      if (observed) {
        observed.add(el);
        return;
      }
      if (observedFallback.indexOf(el) === -1) observedFallback.push(el);
    }

    // Hover dwell (≥500ms) — pointerenter/leave on cells (no child thrash)
    var hoverTimer = null;
    var hoverHandle = null;
    var hoverStartedAt = 0;
    var hoverLogged = {};
    var hoverBound = typeof WeakSet !== 'undefined' ? new WeakSet() : null;
    var hoverBoundFallback = hoverBound ? null : [];
    var lastPtrX = null;
    var lastPtrY = null;

    function clearRailHover() {
      if (hoverTimer) {
        clearTimeout(hoverTimer);
        hoverTimer = null;
      }
      hoverHandle = null;
      hoverStartedAt = 0;
    }

    function alreadyHoverBound(el) {
      if (hoverBound) return hoverBound.has(el);
      return hoverBoundFallback.indexOf(el) !== -1;
    }

    function markHoverBound(el) {
      if (hoverBound) {
        hoverBound.add(el);
        return;
      }
      if (hoverBoundFallback.indexOf(el) === -1) hoverBoundFallback.push(el);
    }

    function onPtrMove(e) {
      if (!e) return;
      if (typeof e.clientX === 'number') lastPtrX = e.clientX;
      if (typeof e.clientY === 'number') lastPtrY = e.clientY;
    }

    // Track pointer while hovering the rail; cancel pending hover on scroll.
    scroller.addEventListener('pointermove', onPtrMove, { passive: true });
    track.addEventListener('pointermove', onPtrMove, { passive: true });
    scroller.addEventListener(
      'scroll',
      function () {
        if (hoverTimer) clearRailHover();
      },
      { passive: true }
    );

    function bindCellHover(cell) {
      if (!cell || alreadyHoverBound(cell)) return;
      markHoverBound(cell);
      cell.addEventListener('pointerenter', function (e) {
        var meta = cellMeta(cell);
        if (!meta) return;
        if (e && typeof e.clientX === 'number') {
          lastPtrX = e.clientX;
          lastPtrY = e.clientY;
        }
        if (hoverHandle === meta.handle && hoverTimer) return;
        clearRailHover();
        hoverHandle = meta.handle;
        hoverStartedAt = Date.now();
        hoverTimer = setTimeout(
          (function (m) {
            return function () {
              hoverTimer = null;
              var dwell = Date.now() - hoverStartedAt;
              if (dwell < HOVER_MS) return;
              // Confirm pointer still over the same cell (adjacent bleed guard).
              if (!hoverStillOnHandle(m.handle, lastPtrX, lastPtrY)) return;
              if (hoverHandle !== m.handle) return;
              if (hoverLogged[m.handle]) {
                promoteHoverFocus(m);
                return;
              }
              hoverLogged[m.handle] = true;
              recordHover(m, dwell);
            };
          })(meta),
          HOVER_MS
        );
      });
      cell.addEventListener('pointerleave', function () {
        var meta = cellMeta(cell);
        if (meta && meta.handle === hoverHandle) clearRailHover();
      });
    }

    function bindAllCellHovers() {
      var cells = track.querySelectorAll('.wmn-rg-rail__cell[data-wmn-handle]');
      for (var i = 0; i < cells.length; i++) bindCellHover(cells[i]);
    }

    // Clicks — delegation covers SSR + dynamically appended cards
    track.addEventListener(
      'click',
      function (e) {
        var t = e.target;
        if (!t || !t.closest) return;
        var card = t.closest('.wmn-rg-rail__card');
        if (!card || !track.contains(card)) return;
        var cell = card.closest('.wmn-rg-rail__cell');
        var meta = cellMeta(cell);
        if (!meta) return;
        recordClick(meta);
      },
      true
    );

    // Cell impressions / dwell (≥1s mostly visible)
    var cellIo = null;
    if (typeof window.IntersectionObserver === 'function') {
      cellIo = new IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) {
            var entry = entries[i];
            var cell = entry.target;
            var meta = cellMeta(cell);
            if (!meta) continue;
            var h = meta.handle;
            if (entry.isIntersecting && entry.intersectionRatio >= 0.45) {
              if (!cellSeenAt[h]) cellSeenAt[h] = Date.now();
              if (visibleLogged[h] || visibleTimers[h]) continue;
              visibleTimers[h] = setTimeout(
                (function (m, el) {
                  return function () {
                    visibleTimers[m.handle] = null;
                    if (visibleLogged[m.handle]) return;
                    var rect = el.getBoundingClientRect();
                    if (
                      rect.width < 8 ||
                      rect.right < 0 ||
                      rect.left > window.innerWidth
                    ) {
                      return;
                    }
                    visibleLogged[m.handle] = true;
                    var dwell = cellSeenAt[m.handle]
                      ? Date.now() - cellSeenAt[m.handle]
                      : VISIBLE_MS;
                    recordVisible(m, Math.max(VISIBLE_MS, dwell));
                  };
                })(meta, cell),
                VISIBLE_MS
              );
            } else {
              if (visibleTimers[h]) {
                clearTimeout(visibleTimers[h]);
                visibleTimers[h] = null;
              }
              if (cellSeenAt[h]) delete cellSeenAt[h];
            }
          }
        },
        { root: null, threshold: [0.45, 0.6] }
      );
    }

    function observeCells() {
      var cells = track.querySelectorAll('.wmn-rg-rail__cell[data-wmn-handle]');
      for (var i = 0; i < cells.length; i++) {
        if (cellIo && !alreadyObserved(cells[i])) {
          markObserved(cells[i]);
          cellIo.observe(cells[i]);
        }
      }
      bindAllCellHovers();
    }

    // Section-level dwell (rail in viewport ≥2s once)
    if (typeof window.IntersectionObserver === 'function') {
      var sectionIo = new IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) {
            var entry = entries[i];
            if (entry.isIntersecting && entry.intersectionRatio >= 0.2) {
              if (!sectionDwellStarted) sectionDwellStarted = Date.now();
            } else if (sectionDwellStarted && !sectionDwellLogged) {
              var ms = Date.now() - sectionDwellStarted;
              sectionDwellStarted = 0;
              if (ms >= 2000) {
                sectionDwellLogged = true;
                logIntent({
                  type: 'section_dwell',
                  dwellMs: ms,
                  meta: { source: SOURCE, collection: collection || null }
                });
              }
            }
          }
        },
        { threshold: [0.2] }
      );
      sectionIo.observe(root);
    }

    function farthestVisibleIndex() {
      var cells = track.querySelectorAll('.wmn-rg-rail__cell[data-wmn-handle]');
      var best = maxIndex;
      var scrollerRect = scroller.getBoundingClientRect();
      for (var i = 0; i < cells.length; i++) {
        var r = cells[i].getBoundingClientRect();
        if (r.left < scrollerRect.right - 8 && r.right > scrollerRect.left + 8) {
          if (i > best) best = i;
        }
      }
      return best;
    }

    function onScroll() {
      if (scrollTimer) return;
      scrollTimer = setTimeout(function () {
        scrollTimer = 0;
        var maxScroll = scroller.scrollWidth - scroller.clientWidth;
        var ratio = maxScroll > 0 ? scroller.scrollLeft / maxScroll : 0;
        if (ratio > maxRatio) maxRatio = ratio;
        var idx = farthestVisibleIndex();
        if (idx > maxIndex) maxIndex = idx;

        for (var m = 0; m < DEPTH_MARKS.length; m++) {
          var mark = DEPTH_MARKS[m];
          var key = String(mark);
          if (firedMarks[key]) continue;
          if (maxRatio + 0.001 < mark) continue;
          firedMarks[key] = true;
          recordScrollDepth({
            ratio: Math.round(maxRatio * 1000) / 1000,
            maxIndex: maxIndex,
            mark: mark,
            collection: collection
          });
          // Soft affinity once when first crossing 50% depth
          if (mark >= 0.5 && !depthAffinityDone) {
            depthAffinityDone = true;
            var cells = track.querySelectorAll(
              '.wmn-rg-rail__cell[data-wmn-handle]'
            );
            var far = cells[maxIndex] || cells[cells.length - 1];
            softDepthAffinity(cellMeta(far), mark);
          }
        }
      }, SCROLL_THROTTLE_MS);
    }

    scroller.addEventListener('scroll', onScroll, { passive: true });

    // Re-observe when infinite rail appends cells
    if (typeof window.MutationObserver === 'function') {
      var mo = new MutationObserver(function () {
        observeCells();
      });
      mo.observe(track, { childList: true });
    }

    observeCells();
    // Initial depth snapshot (no scroll yet)
    onScroll();
  }

  function initRail(root) {
    if (!root || root.getAttribute('data-wmn-rg-ready')) return;
    var collection = root.getAttribute('data-collection') || 'rough-guides';
    var pageSize = parseInt(root.getAttribute('data-page-size'), 10) || 16;
    var nextPage = parseInt(root.getAttribute('data-next-page'), 10) || 2;
    var total = parseInt(root.getAttribute('data-total'), 10) || 0;
    var scroller = root.querySelector('[data-wmn-rg-scroller]');
    var track = root.querySelector('[data-wmn-rg-track]');
    var sentinel = root.querySelector('[data-wmn-rg-sentinel]');
    var status = root.querySelector('[data-wmn-rg-status]');
    if (!scroller || !track || !sentinel) return;

    root.setAttribute('data-wmn-rg-ready', '1');
    var loading = false;
    var done = false;
    var seen = {};

    Array.prototype.forEach.call(
      track.querySelectorAll('[data-wmn-handle]'),
      function (el) {
        var h = el.getAttribute('data-wmn-handle');
        if (h) seen[h] = true;
      }
    );

    function setStatus(show, text) {
      if (!status) return;
      if (text) status.textContent = text;
      status.hidden = !show;
    }

    function maybeDone() {
      if (total > 0 && Object.keys(seen).length >= total) {
        done = true;
        setStatus(false);
      }
    }

    function loadMore() {
      if (loading || done) return;
      loading = true;
      setStatus(true, 'Loading more…');
      var url =
        shopRoot() +
        'collections/' +
        encodeURIComponent(collection) +
        '/products.json?limit=' +
        pageSize +
        '&page=' +
        nextPage;

      fetch(url, { credentials: 'same-origin' })
        .then(function (res) {
          if (!res.ok) throw new Error('rg rail ' + res.status);
          return res.json();
        })
        .then(function (payload) {
          var list = (payload && payload.products) || [];
          if (!list.length) {
            done = true;
            setStatus(false);
            return;
          }
          var html = '';
          var added = 0;
          var i;
          for (i = 0; i < list.length; i++) {
            var p = list[i];
            if (!p || !p.handle || seen[p.handle]) continue;
            var piece = cardHtml(p);
            if (!piece) continue;
            seen[p.handle] = true;
            html += piece;
            added++;
          }
          if (html) {
            track.insertAdjacentHTML('beforeend', html);
          }
          nextPage += 1;
          root.setAttribute('data-next-page', String(nextPage));
          if (added === 0 || list.length < pageSize) {
            done = true;
          }
          maybeDone();
          setStatus(false);
        })
        .catch(function () {
          setStatus(true, 'Couldn’t load more');
        })
        .then(function () {
          loading = false;
        });
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) loadMore();
          });
        },
        { root: scroller, rootMargin: '0px 400px 0px 0px', threshold: 0 }
      );
      io.observe(sentinel);
    } else {
      scroller.addEventListener(
        'scroll',
        function () {
          if (
            scroller.scrollLeft + scroller.clientWidth >=
            scroller.scrollWidth - 480
          ) {
            loadMore();
          }
        },
        { passive: true }
      );
    }

    maybeDone();
    bindTracking(root, scroller, track, collection);
  }

  function boot(root) {
    var nodes = root
      ? root.querySelectorAll
        ? root.querySelectorAll('[data-wmn-rg-rail]')
        : []
      : document.querySelectorAll('[data-wmn-rg-rail]');
    Array.prototype.forEach.call(nodes, initRail);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    boot(e && e.target);
  });
})();
